/**
 * The signed-in user's role(s) as one line of text, for the header menu and My Profile.
 *
 * `/management/userinfo` returns `role` as an ARRAY (`["Guest", "Super Admin"]`), and the users list
 * returns the same thing comma-joined (`"Guest,Super Admin"`), so both shapes are accepted.
 *
 * ⚠️ "Guest" IS DROPPED WHEN THE USER HOLDS ANYTHING ELSE. It is the baseline role nearly every
 * account carries, so "Guest, Commercial" would bury the role that says what the person does. It is
 * shown only when it is the user's sole role.
 *
 * Empty string when there is no role, so a caller can hide the line rather than print a placeholder.
 */
export function roleLabel(role: unknown): string {
  const names = (Array.isArray(role) ? role : typeof role === 'string' ? role.split(',') : [])
    .map((name) => (typeof name === 'string' ? name.trim() : ''))
    .filter((name) => name !== '');
  const unique = [...new Set(names)];
  const meaningful = unique.filter((name) => name.toLowerCase() !== 'guest');
  return (meaningful.length > 0 ? meaningful : unique).join(', ');
}
